import { MutationTree } from 'vuex'

import { ItemState } from '@/types/store'
import { IItem, ItemType } from '@/types/receipt'

export const mutations: MutationTree<ItemState> = {
  itemsLoadStart(state) {
    state.isItemsLoading = true
  },
  itemsLoaded(state, payload: [IItem[], number]) {
    state.items = payload[0]
    state.total = payload[1]
    state.isItemsLoading = false
  },
  itemsRenewed(state, payload: [IItem[], number]) {
    const newIds = payload[0].map(item => item.id)
    state.items = state.items.filter(item => newIds.indexOf(item.id) > -1)
    state.total = payload[1]
  },
  setItemType(state, itemType: ItemType): void {
    state.itemType = itemType
  },
  hideItem(state, item: IItem): void {
    state.items = state.items.filter(i => i.id !== item.id)
    state.total = state.total - 1
  },
}
